import React, { useState } from 'react';
import { Button, Modal, Space } from 'antd';
import dayjs from 'dayjs';
import useService from '@/lib/hooks/useService';
import { detailTitles } from '../detailModalTitles';
import styles from './index.module.scss';
import type { CarServiceReservation } from '@/types/database/carService';
import type { ReservedUser } from '../../types';

interface CheckDetailButtonsWithModalProps {
  reservationId: string | undefined;
}

const CheckDetailButtonsWithModal = ({
  reservationId,
}: CheckDetailButtonsWithModalProps) => {
  const [allReservations] = useService<CarServiceReservation>({
    collectionName: 'carService',
  });
  const [users] = useService<ReservedUser>({
    collectionName: 'users',
  });

  const [isOpenModal, setIsOpenModal] = useState<boolean>(false);

  const reservationData = allReservations.find(
    (reservation) => reservation._id === reservationId
  );

  const reservedUser = users.find(
    (user) => user._id === reservationData?.userId
  );

  const getModalContent = () => {
    if (reservationData) {
      const reservationForModalContent = {
        ...reservationData,
        createdTime: dayjs(reservationData.createdTime).format(
          'YYYY-MM-DD HH:mm'
        ),
        reservationTime: dayjs(reservationData.reservationTime).format(
          'YYYY-MM-DD HH:mm'
        ),
        actualCarTime: dayjs(reservationData.actualCarTime).format(
          'YYYY-MM-DD HH:mm'
        ),
        estimatedArrivalTime: dayjs(
          reservationData.estimatedArrivalTime
        ).format('YYYY-MM-DD HH:mm'),
        actualArrivalTime: dayjs(reservationData.actualArrivalTime).format(
          'YYYY-MM-DD HH:mm'
        ),
      };

      for (const key in reservationForModalContent) {
        if (reservationForModalContent[key] === 'Invalid Date') {
          reservationForModalContent[key] = '';
        }
      }

      const modalContents = detailTitles.map((titleObj) => {
        const { title, value } = titleObj;
        switch (title) {
          case '戶號':
            return {
              title,
              content: reservedUser?.householdNumbers[0],
            };

          case '住戶':
            return {
              title,
              content: reservedUser?.name,
            };

          default:
            return {
              title,
              content: reservationForModalContent[value],
            };
        }
      });
      return modalContents.map((content) => (
        <div key={content.title}>
          <h5 className={styles.modalContentTitle}>{content.title}</h5>
          <p>{content.content}</p>
        </div>
      ));
    } else {
      return [];
    }
  };

  return (
    <Space>
      <Modal
        open={isOpenModal}
        closable={false}
        onCancel={() => setIsOpenModal(false)}
        footer={
          <div className={styles.modalFooter}>
            <Button onClick={() => setIsOpenModal(false)}>確認</Button>
          </div>
        }
      >
        <h2 className={styles.modalHeader}>叫車預約</h2>
        <Space direction="vertical" size="middle">
          {getModalContent()}
        </Space>
      </Modal>
      <Button type="primary" onClick={() => setIsOpenModal(true)}>
        查看
      </Button>
    </Space>
  );
};

export default CheckDetailButtonsWithModal;
